/**
 * Image lightbox for `a.lightbox-image` links (ekko-lightbox replacement).
 * Delegated, so rows added later (DataGrid renders, dynamic tables) work without re-init.
 */
import { DModal } from './Modal';

let bound = false;

export function initLightbox() {
    if (bound) return;
    bound = true;
    document.addEventListener('click', (e) => {
        const link = e.target.closest('a.lightbox-image');
        if (!link) return;
        e.preventDefault();
        const modl = new DModal();
        modl.createModal({
            headerClass: 'd-none',
            footerClass: 'd-none',
            dialogClass: 'modal-lg modal-dialog-centered',
            bodyClass: 'p-0 text-center',
        });
        const img = document.createElement('img');
        img.src = link.getAttribute('href');
        img.className = 'img-fluid';
        img.alt = link.getAttribute('title') || '';
        img.addEventListener('click', () => modl.hide());
        modl.modal.querySelector('.modal-body').appendChild(img);
        modl.show();
    });
}
